import React, { useState } from "react";
import GaugeChart from "react-gauge-chart";

const FarmerReportGaugeChart = ({ farmerDataCl, chartName }) => {
  const [value, setValue] = useState(0.1);
  const per = farmerDataCl / 100;

  const defaultper = 0;

  return (
    <React.Fragment>
      <GaugeChart
        id="gauge-chart3"
        nrOfLevels={30}
        colors={["#EA4228", "#F5CD19", "#5BE12C"]}
        arcWidth={0.3}
        percent={farmerDataCl && farmerDataCl ? per : defaultper}
        textColor={"black"}
        className="my-3"
        animate={false}
      />
      <h5 className=" text-center steelblue">
        {chartName} : {farmerDataCl ? farmerDataCl?.toFixed(2) : farmerDataCl}
      </h5>
      <div className="text-center my-2">
        <div
          className="d-flex flex-wrap justify-content-between align-items-center bg-white  rounded px-2"
          style={{ fontSize: "0.75rem" }}
        >
          <div
            className="d-flex align-items-center me-1"
            title="ACS < 50: Poor"
          >
            <i
              className="mdi mdi-circle text-danger me-1"
              style={{ fontSize: "0.6rem" }}
            ></i>
            <span className="text-muted me-1">&lt; 50:</span>
            <strong className="text-danger">Poor</strong>
          </div>

          <div
            className="d-flex align-items-center mx-1"
            title="ACS 50–60: Normal"
          >
            <i
              className="mdi mdi-circle me-1"
              style={{ color: "#e7b629", fontSize: "0.6rem" }}
            ></i>
            <span className="text-muted me-1">50–60:</span>
            <strong style={{ color: "#e7b629" }}>Normal</strong>
          </div>

          <div
            className="d-flex align-items-center ms-1"
            title="ACS > 60: Good"
          >
            <i
              className="mdi mdi-circle me-1"
              style={{ fontSize: "0.6rem", color: "#6fe22c" }}
            ></i>
            <span className="text-muted me-1"> 60-80:</span>
            <strong className="" style={{ color: "#6fe22c" }}>
              Good
            </strong>
          </div>
          <div
            className="d-flex align-items-center ms-1"
            title="ACS > 60: Good"
          >
            <i
              className="mdi mdi-circle text-success me-1"
              style={{ fontSize: "0.6rem" }}
            ></i>
            <span className="text-muted me-1">&gt; 80:</span>
            <strong className="text-success"> Very Good</strong>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FarmerReportGaugeChart;

//2nd

// import React, { useState, useEffect } from "react";
// import GaugeChart from "react-gauge-chart";

// const FarmerReportGaugeChart = ({ farmerDataCl,chartName  }) => {
//   const [animatedPercent, setAnimatedPercent] = useState(0);
//   const [animatedValue, setAnimatedValue] = useState(0);

//   useEffect(() => {
//     if (!farmerDataCl) return;
//     const targetPercent = farmerDataCl / 100;
//     const targetValue = farmerDataCl;
//     let startTime = null;
//     const duration = 1000;
//     const animate = (timestamp) => {
//       if (!startTime) startTime = timestamp;
//       const progress = Math.min((timestamp - startTime) / duration, 1);
//       setAnimatedPercent(progress * targetPercent);
//       setAnimatedValue(progress * targetValue);
//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       }
//     };

//     requestAnimationFrame(animate);
//   }, [farmerDataCl]);

//   return (
//     <React.Fragment>
//       <GaugeChart
//         id="gauge-chart3"
//         nrOfLevels={30}
//         colors={["#EA4228", "#F5CD19", "#5BE12C"]}
//         arcWidth={0.3}
//         percent={farmerDataCl ? animatedPercent : 0}
//         textColor={"black"}
//         className="my-3"
//       />
//       <h5 className="text-center steelblue">
//         {chartName} : {farmerDataCl ? animatedValue.toFixed(1) : "-"}
//       </h5>
//       <div className="text-center my-2">
//         <div
//           className="d-flex justify-content-between align-items-center bg-white rounded px-2"
//           style={{ fontSize: "0.75rem" }}
//         >
//           <div
//             className="d-flex align-items-center me-1"
//             title="ACS < 50: Poor"
//           >
//             <i
//               className="mdi mdi-circle text-danger me-1"
//               style={{ fontSize: "0.65rem" }}
//             ></i>
//             <span className="text-muted me-1">&lt; 50:</span>
//             <strong className="text-danger">Poor</strong>
//           </div>

//           <div
//             className="d-flex align-items-center mx-1"
//             title="ACS 50–60: Normal"
//           >
//             <i
//               className="mdi mdi-circle me-1"
//               style={{ color: "#ffc107", fontSize: "0.65rem" }}
//             ></i>
//             <span className="text-muted me-1">50–60:</span>
//             <strong style={{ color: "#ffc107" }}>Normal</strong>
//           </div>

//           <div
//             className="d-flex align-items-center ms-1"
//             title="ACS > 60: Good"
//           >
//             <i
//               className="mdi mdi-circle text-success me-1"
//               style={{ fontSize: "0.65rem" }}
//             ></i>
//             <span className="text-muted me-1">&gt; 60:</span>
//             <strong className="text-success">Good</strong>
//           </div>
//         </div>
//       </div>
//     </React.Fragment>
//   );
// };

// export default FarmerReportGaugeChart;

// import React, { useEffect, useState } from "react";
// import GaugeChart from "react-gauge-chart";

// const FarmerReportGaugeChart = ({ farmerDataCl, chartName, scores }) => {
//   const [animatedPercent, setAnimatedPercent] = useState(0);
//   const [animatedValue, setAnimatedValue] = useState(0);

//   // 1️⃣ Safely build score options from ACS
//   const scoreOptions =
//     scores?.ACS?.flatMap((entry) =>
//       Object.entries(entry).map(([date, value]) => ({
//         date,
//         value: Number(value),
//       }))
//     ) ?? [];

//   // 2️⃣ Track selected date and ensure it starts with the first option if available
//   const [selectedDate, setSelectedDate] = useState("");

//   useEffect(() => {
//     if (scoreOptions.length && !selectedDate) {
//       setSelectedDate(scoreOptions[0].date);
//     }
//   }, [scoreOptions, selectedDate]);

//   // 3️⃣ Get selected value or fallbacks
//   const selectedValue =
//     scoreOptions.find((item) => item.date === selectedDate)?.value ??
//     scoreOptions[0]?.value;

//   const displayValue =
//     selectedValue !== undefined ? selectedValue : farmerDataCl ?? 0;

//   // 4️⃣ Animate on displayValue change
//   useEffect(() => {
//     const targetPercent = displayValue / 100;
//     const duration = 1000;
//     let startTime = null;

//     const animate = (timestamp) => {
//       if (!startTime) startTime = timestamp;
//       const progress = Math.min((timestamp - startTime) / duration, 1);
//       setAnimatedPercent(progress * targetPercent);
//       setAnimatedValue(progress * displayValue);
//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       }
//     };

//     requestAnimationFrame(animate);
//   }, [displayValue]);
//     console.log("scoreOptions",scoreOptions)
//   return (
//     <React.Fragment>
//       {/* Top-right small dropdown */}
//       {scoreOptions.length > 0 && (
//         <div className="d-flex justify-content-end mt-2 me-2">
//           <select
//             value={selectedDate}
//             onChange={(e) => setSelectedDate(e.target.value)}
//             className="form-select form-select-sm w-auto mb-1"
//             title="Select score date"
//           >
//             {scoreOptions.map(({ date }) => (
//               <option key={date} value={date}>
//                 {date}
//               </option>
//             ))}
//           </select>
//         </div>
//       )}

//       {/* Gauge */}
//       <GaugeChart
//         id="gauge-chart3"
//         nrOfLevels={30}
//         colors={["#EA4228", "#F5CD19", "#5BE12C"]}
//         arcWidth={0.3}
//         percent={animatedPercent}
//         textColor="black"
//         className="my-2"
//       />

//       {/* Title with animated value */}
//       <h5 className="text-center steelblue">
//         {chartName} : {animatedValue.toFixed(1)}
//       </h5>

//       {/* Legend */}
//       <div className="text-center my-2">
//         <div
//           className="d-flex justify-content-between align-items-center bg-white rounded px-2"
//           style={{ fontSize: "0.75rem" }}
//         >
//           <div className="d-flex align-items-center me-1" title="ACS < 50: Poor">
//             <i className="mdi mdi-circle text-danger me-1" style={{ fontSize: "0.65rem" }}></i>
//             <span className="text-muted me-1">&lt; 50:</span>
//             <strong className="text-danger">Poor</strong>
//           </div>
//           <div className="d-flex align-items-center mx-1" title="ACS 50–60: Normal">
//             <i className="mdi mdi-circle me-1" style={{ color: "#ffc107", fontSize: "0.65rem" }}></i>
//             <span className="text-muted me-1">50–60:</span>
//             <strong style={{ color: "#ffc107" }}>Normal</strong>
//           </div>
//           <div className="d-flex align-items-center ms-1" title="ACS > 60: Good">
//             <i className="mdi mdi-circle text-success me-1" style={{ fontSize: "0.65rem" }}></i>
//             <span className="text-muted me-1">&gt; 60:</span>
//             <strong className="text-success">Good</strong>
//           </div>
//         </div>
//       </div>
//     </React.Fragment>
//   );
// };

// export default FarmerReportGaugeChart;
